<inbox-filters
  #inboxFilters
  id="ordersSearch"
  class="l-block"
  (onSearch)="getOrdersBySearch($event)"
  (onResultsPerPageChanged)="onResultsPerPageChanged()"
></inbox-filters>

<loader *ngIf="ordersLoading" class="t-mar-top"></loader>

<div
  *ngIf="displayOrders && !displayOrders.length && !ordersLoading"
  role="alert"
  class="c-alert t-alert-info"
>
  {{ "translate.alert.noResults" | translate }}
</div>

<inbox-list
  [displayOrders]="displayOrders"
  [totalRecords]="orderSearchMetadata?.totalRecords"
  [numberOfRows]="numberOfRows"
  [metaData]="orderSearchMetadata"
  (onPagination)="loadDataOnPagination($event)"
  (onRowSelected)="onOrderSelected($event)"
  (onGoToChat)="onGoToChat($event)"
  (onMarkFavorite)="onMarkFavorite($event)"
  (onDownloadSelectedRX)="onDownloadSelectedRX()"
  (onDownloadRXOnPage)="onDownloadRXOnPage()"
></inbox-list>

<modal-popup
  *ngIf="displayRXDownloadStatusDialog"
  [flexible]="true"
  [hideHeader]="false"
  [title]="'translate.inbox.rxDownloadStatusTitle'"
  [isOpen]="displayRXDownloadStatusDialog"
  (onClose)="displayRXDownloadStatusDialog = false"
  [focusOnOpen]="false"
>
  <div class="downloadFileDialogContainer">
    <div *ngIf="rxDownloadLoading">
      <p>{{ "translate.inbox.downloadingRXLoadingMsg" | translate }}</p>
      <br />
      <loader></loader>
    </div>

    <div *ngIf="!rxDownloadLoading && rxDownloadFileUrl">
      <p>{{ "translate.inbox.downloadRXFileReady" | translate }}</p>
      <br />
      <p>
        <span>{{ "translate.inbox.downloadRXFileLinkPart1" | translate }}</span>
        <a [href]="rxDownloadFileUrl" target="_blank">{{
          "translate.inbox.downloadRXFileLinkClickHere" | translate
        }}</a>
        <span>{{ "translate.inbox.downloadRXFileLinkPart2" | translate }}</span>
      </p>
    </div>
  </div>
</modal-popup>
